import React from 'react';
// import Video2 from '../../images/v-shape.jpg'

const VideoSectionS2 = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="wpo-video-item">
                    <div className="row">
                        <div className={`col-lg-12 col-md-12 col-12 ${props.Vbuttom}`}>
                            <div className="why-choose-wrap">
                                <div className="why-choose-left">
                                    <h2>Почему именно мы?   </h2>
                                    <p>Мы обеспечиваем быструю, безопасную и эффективную логистику. Наш опыт, современные технологии и индивидуальный подход гарантируют надёжную доставку. Мы предлагаем оптимальные маршруты, контроль на всех этапах перевозки и высокое качество сервиса. Доверьте нам ваш груз – мы доставим его точно в срок!</p>
                                </div>
                                <div className="why-choose-right">
                                    <div className="wpo-choose-check-wrap">
                                        <div className="wpo-choose-check-item">
                                            <h2>Безопасность</h2>
                                            <p>Полный контроль и сохранность грузов на всех стадиях транспортировки.</p>
                                        </div>
                                        <div className="wpo-choose-check-item">
                                            <h2>Быстрая доставка</h2>
                                            <p>
                                                Быстрая доставка

                                                Наша компания предлагает услуги быстрой доставки для тех, кто ценит время и нуждается в оперативном решении транспортных задач.
                                            </p>
                                        </div>
                                        <div className="wpo-choose-check-item">
                                            <h2>Ценообразования</h2>
                                            <p>Стоимость наших услуг рассчитывается индивидуально, с учетом специфики вашего груза, маршрута и дополнительных требований.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="v-shape">
                                    <img src={Video2} alt="" />
                                </div> */}
                            </div>
                        </div>
                        {/* <div className={`col-lg-12 col-md-12 col-12 ${props.Vtop}`} >
                            <div className="wpo-video-icon ">
                                <VideoModal />
                            </div>
                            <div className="wpo-viedo-title">
                                <h2>Посмотрите наше вступительное видео и узнайте, как легко получить наши услуги.</h2>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoSectionS2;